import { lazy } from "react";
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';

const VendorRequestList = lazy(() => import("../components/vendor-request-list"));
const VendorRequestView = lazy(() => import("../components/vendor-request-view"));
const VendorInvite = lazy(() => import("../components/invite-vendor"));

const vendorRequestRoute = {
  icon: EmojiTransportationIcon,
  name: "Cab Vendor",
  link: "/cab-vendor",
  path: "cab-vendor",
  index: 3,
  superAdminView: false,
  element: "",
  children: [
    {
      path: "vendor-requests",
      element: <VendorRequestList />,
      // name: "Organization Vendor Request",
      link: "/cab-vendor/vendor-requests",
      icon: EmojiTransportationIcon,
      index: 1,
      superAdminView: false,
    },
    {
      path: "vendor-requests/create",
      element: <VendorInvite />,
    },
    {
      path: "vendor-requests/:id",
      element: <VendorRequestView />,
    },
    // {
    //   path: "",
    //   element: <Navigate to="vendors" replace />,
    // },
  ],
};
export default vendorRequestRoute;
